import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemDirective, ItemsDirective } from './items.directive';
import { ToolbarComponent } from './toolbar.component';
import { ToolbarModule } from './toolbar.module';
/**
 * NgModule definition for the Toolbar component with providers.
 */
export class ToolbarAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, ToolbarModule],
    exports: [
        ToolbarModule
    ],
    providers:[
        
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ToolbarAllModule_tsickle_Closure_declarations() {
/** @type {?} */
ToolbarAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ToolbarAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
